export default "__VITE_ASSET__LOU0Libc__"